import { render } from "./JiGouDetail.vue?vue&type=template&id=4a6c7409&scoped=true"
import script from "./JiGouDetail.vue?vue&type=script&lang=js"
export * from "./JiGouDetail.vue?vue&type=script&lang=js"

import "./JiGouDetail.vue?vue&type=style&index=0&id=4a6c7409&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6c7409"]])

export default __exports__